import { getRequest } from '../api'

const baseUrl = isExternal => `${isExternal ? '/client' : ''}/packages`

export const getPackages = () => getRequest('/package')
export const getPackageJobs = (packageName, isExternal) => `${baseUrl(isExternal)}/${packageName}/jobs`
